module.exports = __webpack_public_path__ + "img/icon44.de48becd.png";